import genReducer from '../core/reducer';
import types from './types';
import initialState from './initialState';

export const CATEGORIES_MODEL = 'categories';

export default genReducer(types, initialState);
